import { afterNextRender, Component, effect, inject, input, PLATFORM_ID } from '@angular/core';
import { AuthStore } from '../../authentication/authStore';
import { isPlatformBrowser } from '@angular/common';
import { SsrBrowserContextService } from '../../context/ssrBrowserContextService';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { UsertStore } from '../../context/userStore';

@Component({
  selector: 'app-login',
  imports: [
    NzButtonModule,
    NzFlexModule,
    NzSpinComponent
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
   constructor() {
    effect(() => {
      if (this.forceLogin()) {
        this.login();
      }
    });
  }
  forceLogin = input(false);
  
  auth = inject(AuthStore);
  userStore = inject(UsertStore);
  ssrBrowserContextService = inject(SsrBrowserContextService);

  ngOnInit(): void { 
    if (!this.ssrBrowserContextService.isBrowser) {
      return; 
    }
    if(!this.auth.loggedIn() && !this.auth.isLoading()) {
      this.auth.login();
    }
  }
  login(){
     this.auth.login();
  }
}
